import React from "react";

// EV IQ wordmark — uses the official PNG logo from /eviq-logo.png
export const Logo = ({ size = 28, showWordmark = true }) => (
  <div
    className="flex items-center gap-2.5"
    data-testid="ev-iq-logo"
    aria-label="EV IQ"
  >
    <img
      src="/eviq-logo.png"
      alt="EVIQ"
      width={size}
      height={size}
      className="rounded-[6px] shrink-0"
      style={{ width: size, height: size, objectFit: "contain" }}
    />
    {showWordmark && (
      <span
        className="font-display font-semibold tracking-tight leading-none"
        style={{ fontSize: Math.max(14, size * 0.78) }}
      >
        <span className="text-white">EV</span>
        <span className="brand-text-gradient ml-0.5">IQ</span>
      </span>
    )}
  </div>
);
